<template>
    <div class="content__container courier_content">
        <div v-if="isShowMenu" class="menu_couriers">
            <div class="menu_couriers__list_search">
                <search_block
                    v-if="isCouriersList"
                    :key="'search_block_'"
                    :placeholderText="__t('O.SEARCH_DATA')"
                    @search_input_data="searchInputData"
                />
            </div>
            <div v-if="!isCouriersList" class="menu_couriers__list_container" :class="classNoOrders">
                <div class="menu_couriers__list_no_couriers">
                    {{ __t('O.NO_OPEN_ORDERS') }}
                </div>
            </div>
            <div v-else class="menu_couriers__list">
                <menu_couriers_item
                    v-for="item in listOrders"
                    :key="'menu_orders_item_'+item.id"
                    :courierItem="item"
                />
            </div>
        </div>
        <spinner
            v-if="isMakeOrder"
            :height="'60px'"
            :width="'10px'"
        />
        <div v-if="isShowCourier" class="courier">
            <div class="courier__wrapper">
                <div v-if="isCouriersList" class="courier__wrapper_content">
                    <div v-if="isMobileScreen" class="courier_new__heading">
                        <div class="courier_new__heading_back" @click.prevent="clickBackArrow">
                            <div class="courier_new__heading_back_arrow margin_left">
                                <svg>
                                    <use xlink:href="/icons/base.svg#back_arrow"></use>
                                </svg>
                            </div>
                            <div class="courier__heading_back_text">
                                {{ __t('O.BACK') }}
                            </div>
                        </div>
                    </div>
                    <div class="courier__wrapper_content_data">
                        <div class="courier__wrapper_content_data_take_delivery">
                            <div class="courier_take">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <div class="courier_title_number">
                                                <span class="courier_title_number_text">1</span>
                                            </div>
                                            <span class="courier_title_text">{{ __t('O.PICK_UP_ORDER') }}</span>
                                        </div>
                                    </div>
                                    <spinner
                                        v-if="isLoadingInfo"
                                        :height="'40px'"
                                        :width="'4px'"
                                    />
                                    <div v-else class="courier__list">
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.RESTAURANT') }}</span>
                                            <div class="courier_info_details">
                                                <span class="courier_info_details_text">{{ restName }}</span>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.ADDRESS') }}</span>
                                            <div class="courier_info_details">
                                                <span class="courier_info_details_text">{{ restAddress }}</span>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.COMMENT') }}</span>
                                            <div class="courier_info_details">
                                                <textarea
                                                    rows="4"
                                                    cols="50"
                                                    class="courier_info_details_input"
                                                    :placeholder="__t('O.ENTER_COMMENT')"
                                                    v-model="restComment"
                                                >
                                                    {{ restComment }}
                                                </textarea>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.RESTAURANT_INFO') }}</span>
                                            <div class="courier_info_details">
                                                <span class="courier_info_details_text">{{
                                                        __t('O.RESTAURANT_CONTACT')
                                                    }}</span>
                                                <span class="courier_info_details_phone">{{ restPhone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="courier_delivery">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <div class="courier_title_number">
                                                <span class="courier_title_number_text">2</span>
                                            </div>
                                            <span class="courier_title_text">{{ __t('O.DELIVER_ORDER') }}</span>
                                        </div>
                                        <button class="courier_title_edit" @click.prevent="openAddress">
                                            <svg>
                                                <use xlink:href="/icons/base.svg#icon_edit"></use>
                                            </svg>
                                        </button>
                                    </div>
                                    <spinner
                                        v-if="isLoadingInfo"
                                        :height="'40px'"
                                        :width="'4px'"
                                    />
                                    <div v-else class="courier__list">
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.ADDRESS') }}</span>
                                            <div class="courier_info_details_icon">
                                                <span class="courier_info_details_text">{{ clientAddress }}</span>
                                                <div class="courier_info_details_icon_block">
                                                    <div class="courier_info_details_icon_block_icon">
                                                        <svg>
                                                            <use xlink:href="/icons/base.svg#icon_flag"></use>
                                                        </svg>
                                                    </div>
                                                    <span class="courier_info_details_icon_block_label">{{
                                                            clientDistance
                                                        }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.COMMENT') }}</span>
                                            <div class="courier_info_details">
                                                <textarea
                                                    rows="4"
                                                    cols="50"
                                                    class="courier_info_details_input"
                                                    :placeholder="__t('O.ENTER_COMMENT')"
                                                    v-model="clientComment"
                                                >
                                                    {{ clientComment }}
                                                </textarea>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.CLIENT') }}</span>
                                            <div class="courier_info_details">
                                                <input class="courier_info_details_text"
                                                       :placeholder="__t('O.ENTER_CLIENT_NAME')"
                                                       v-model="clientName"
                                                >
                                                <span class="courier_info_details_phone">{{ clientPhone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="courier__wrapper_content_data_details_contact">
                            <div class="courier_details">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <span class="courier_title_text">{{ __t('O.ORDER_DETAILS') }}</span>
                                        </div>
                                    </div>
                                    <spinner
                                        v-if="isLoadingInfo"
                                        :height="'40px'"
                                        :width="'4px'"
                                    />
                                    <div v-else class="courier__list details">
                                        <div class="courier_products">
                                            <span class="courier_products_label">{{ __t('O.POSITIONS') }}</span>
                                            <div class="courier_products_list">
                                                {{ orderPositions }}
                                            </div>
                                        </div>
                                        <div class="courier_total">
                                            <span class="courier_total_label">{{ __t('O.TOTAL') }}</span>
                                            <span class="courier_total_sum">{{ totalSumWithCurrency }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="courier_contact">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <span class="courier_title_text">{{ __t('O.COURIER') }}</span>
                                        </div>
                                    </div>
                                    <spinner
                                        v-if="isLoadingInfo"
                                        :height="'40px'"
                                        :width="'4px'"
                                    />
                                    <div v-else class="courier__list details">
                                        <div class="courier_aggregator_list">
                                            <div class="courier_aggregator_select">
                                                <div class="courier_aggregator_select_title">
                                                    {{ titleAggregator }}
                                                </div>
                                                <div class="courier_aggregator_select_uniq_id">
                                                    {{ uniqIdLocation }}
                                                </div>
                                                <div class="products_without_groups__filters_input_block">
                                                    <div class="products_without_groups__filters_input_block_select">
                                                        <v_select
                                                            :key="'select_location'"
                                                            :placeholder="__t('O.SELECT_LOCATION')"
                                                            :options="optionsLocations"
                                                            label="title"
                                                            v-model="selectLocationCourier"
                                                            @update:modelValue="updateLocationSelect"
                                                        >

                                                            <template #selected-option="{ title, provider }">
                                                                <div class="selected-item d-flex-row-select">
                                                                    <span v-html="provider.icon"
                                                                          class="icon-size-24"></span>
                                                                    <span>{{ title }}</span>
                                                                </div>
                                                            </template>

                                                            <template #option="{ title, provider}">
                                                                <div class="dropdown-item d-flex-row-select">
                                                                    <span v-html="provider.icon"
                                                                          class="icon-size-24"></span>
                                                                    <span>{{ title }}</span>
                                                                </div>
                                                            </template>

                                                        </v_select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="courier_select">
                                            <span class="courier_select_title">{{ __t('O.PAYMENT_METHOD') }}</span>
                                            <div class="courier_select_block">
                                                <radio_custom
                                                    v-for="item in paymentList"
                                                    :key="'radio' + item.id"
                                                    :item="item"
                                                    :modelValue="selectedPayment"
                                                    @update:modelValue="clickPayment"
                                                />
                                            </div>
                                        </div>
                                        <div class="courier_select">
                                            <span class="courier_select_title">{{ __t('O.TIME_DELIVERY') }}</span>
                                            <div class="courier_select_block">
                                                <radio_custom
                                                    v-for="item in deliveryOptionsList"
                                                    :key="'radio' + item.id"
                                                    :item="item"
                                                    :modelValue="selectedDeliveryOption"
                                                    @update:modelValue="clickDeliveryOptions"
                                                />
                                            </div>
                                            <div v-if="showBlockASAP" class="courier_select_block">
                                                <div class="courier_info_details start">
                                                    <div class="courier_info_details_img">
                                                        <svg>
                                                            <use xlink:href="/icons/base.svg#people"></use>
                                                        </svg>
                                                    </div>
                                                    <div class="courier_info_details_text">
                                                        {{ timeASAP }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="showBlockDate" class="courier_select_block">
                                                <div class="courier_select_block_choose">
                                                    <div class="courier_select_block_choose_date_block">
                                                        <div class="courier_select_block_choose_label">
                                                            {{
                                                                __t('O.SELECTED_DATE_LABEL')
                                                            }}
                                                        </div>
                                                        <div class="courier_select_block_choose_date_block_value">
                                                            <date_picker
                                                                :key="'select_date'"
                                                                v-model:value="selectDate"
                                                                value-type="format"
                                                                format="DD.MM.YYYY"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="courier_select_block_choose_time_block">
                                                        <div class="courier_select_block_choose_label">{{
                                                                __t('O.SELECTED_TIME_LABEL')
                                                            }}
                                                        </div>
                                                        <div class="courier_select_block_choose_time_block_value">
                                                            <date_picker
                                                                :key="'select_time'"
                                                                v-model:value="selectTime"
                                                                :time-picker-options="{
                                                                        start: '08:00',
                                                                        step: '00:30',
                                                                        end: '18:00'
                                                                    }"
                                                                type="time"
                                                                format="HH:mm"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="courier__wrapper_content_buttons">
                        <button class="courier_button color accept" @click.prevent="clickCourierCall">
                            <span class="courier_button_text">{{ __t('O.COURIER_CALL') }}</span>
                        </button>
                        <!--                        <button class="courier_button" @click.prevent="clickCancel">-->
                        <!--                            <span class="courier_button_text">{{ __t('O.CANCEL') }}</span>-->
                        <!--                        </button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <modal
        v-if="statusModalAddress"
        :key="'modal_address_' + activeCourierId"
    >
        <template v-slot:content>
            <modal_address
                :key="'modal_select_time_' + activeCourierId"
                :addressInfo="addressInfo"
                @save_address="saveAddress"
                @close_address="closeAddress"
            />
        </template>
    </modal>

</template>

<script>

import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import formatNumber from "../../../mixins/formatNumber";
import courier_aggregator_block from "./../aggregator/CourierAggregatorBlock.vue";
import checkbox_custom from "../../CheckboxCustom.vue";
import modal from "../../modal/Modal.vue";
import modal_address from "../../modal/address/ModalAddress.vue";
import spinner from "../../loader/Spinner.vue";
import date_picker from 'vue-datepicker-next';
import 'vue-datepicker-next/locale/en';
import {formatDateTime} from '../../../helpers/formatDateTime';
import {getDateTime} from "../../../helpers/getDateTime";
import {errorOutput} from "../../../helpers/errorOutput";
import {useToast} from 'vue-toastification';
import {__t} from "../../../helpers/translate";
import radio_custom from "../../RadioCustom.vue";
import getObjectPathProperty from "../../../mixins/getObjectPathProperty";
import menu_couriers_item from "../../menu/courier_pos/MenuCouriersItem.vue";
import v_select from "vue-select";
import search_block from "../../rest/SearchBlock.vue";

const toast = useToast();


const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})


export default {
    name: "courier",
    mixins: [formatNumber, screenSize],
    components: {
        search_block,
        v_select,
        menu_couriers_item,
        radio_custom,
        spinner,
        courier_aggregator_block,
        checkbox_custom,
        modal,
        modal_address,
        date_picker
    },
    emits: ['click_back_arrow'],
    data() {
        return {
            addressInfo: {
                address: '',
                house: '',
                entrance: '',
                flat: '',
            },
            statusModalAddress: false,
            aggregatorsList: [],
            selectDate: null,
            selectTime: null,
            chooseTime: false,
            paymentList: [
                {id: 'cash', label: __t('O.CASH'), value: 1, name: 'payment'},
                {id: 'online', label: __t('O.ONLINE'), value: 2, name: 'payment'},
            ],
            selectedPayment: 1,
            deliveryOptionsList: [
                {id: 'asap', label: __t('O.AS_SOON_AS_POSSIBLE'), value: 1, name: 'deliveryTime'},
                {id: 'time', label: __t('O.SELECT_TIME'), value: 2, name: 'deliveryTime'},
            ],
            selectedDeliveryOption: 1,
            clientComment: '',
            restComment: '',
            clientName: '',
            regTemplate: '',
            listOrders: [],
            optionsLocations: [],
        }
    },
    beforeMount() {
        if (this.ordersPos && this.ordersPos.data && Array.isArray(this.ordersPos.data)) {
            this.listOrders = this.ordersPos.data;
        }
        EventBus.$on('get_order_by_location', this.loadOrderInfoByLocation);
        EventBus.$on('make_order_loading', this.makeOrderLoading);
        EventBus.$on('order_not_found', this.orderNotFound);
        EventBus.$on('fetch_order_rest_locations', this.fetchOrderRest);

    },
    beforeUnmount() {
        EventBus.$off('get_order_by_location', this.loadOrderInfoByLocation);
        EventBus.$off('make_order_loading', this.makeOrderLoading);
        EventBus.$off('order_not_found', this.orderNotFound);
        EventBus.$off('fetch_order_rest_locations', this.fetchOrderRest);
    },
    methods: {
        fetchOrderRest(orderRestLocations){
            this.optionsLocations = orderRestLocations;
        },
        searchInputData(searchData) {
            //this.regTemplate = '(^|\\s)' + searchData;
            this.regTemplate = searchData;
            let regex = new RegExp(this.regTemplate, 'gi');
            this.listOrders = this.ordersPos.data;
            this.listOrders = this.listOrders.filter(order => {

                regex = new RegExp(this.regTemplate, 'gi');
                if (order.uniq_id && regex.test(order.uniq_id)) {
                    return true;
                }

                regex = new RegExp(this.regTemplate, 'gi');
                if (order.transaction_id && regex.test(order.transaction_id)) {
                    return true;
                }

                regex = new RegExp(this.regTemplate, 'gi');
                if (order.created && regex.test(order.created)) {
                    return true;
                }

                regex = new RegExp(this.regTemplate, 'gi');
                if (order.comment && regex.test(order.comment)) {
                    return true;
                }
            });
        },
        updateLocationSelect(location) {
            if(location && location.id){
                this.$store.dispatch('couriers/SELECT_LOCATION_COURIER_NEW_MENU', location);
            }

        },
        orderNotFound() {
            toast.error(__t('O.ORDER_NOT_FOUND'));
            this.$router.push({path: "/new/menu"});
        },
        loadOrderInfoByLocation() {
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.delivery.address')) {
                this.addressInfo.address = this.orderInfoByLocation.order.delivery.address;
            }
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.delivery.house')) {
                this.addressInfo.house = this.orderInfoByLocation.order.delivery.house;
            } else {
                this.addressInfo.house = '';
            }

            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.rest.instruction')) {
                this.restComment = this.orderInfoByLocation.order.rest.instruction;
            }
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.customer.name')) {
                this.clientName = this.orderInfoByLocation.order.customer.name;
            }

        },
        clickAggregator(itemSelect) {
            this.aggregatorsList.forEach(item => item.isSelect = item === itemSelect);
        },
        saveAddress(address) {
            this.addressInfo = address;
            this.closeAddress();
        },
        closeAddress() {
            this.statusModalAddress = false;
        },
        openAddress() {
            this.statusModalAddress = true;
        },
        clickCourierCall() {
            if (this.chooseTime && !this.dateFilled) {
                errorOutput('O.DATE_OR_TIME_MISSING');
                return;
            }
            this.$store.dispatch('couriers/CHANGE_MAKE_ORDER_STATE', true);
            this.$store.dispatch('couriers/MAKE_ORDER', this.newOrderData);
        },
        clickCancel() {
            this.$store.dispatch('couriers/CHANGE_MAKE_ORDER_STATE', false);
            this.$store.dispatch('couriers/CHANGE_STATE_NEW_COURIER', false);
            this.$router.push({path: "/courier"});
        },
        clickBackArrow() {
            if (this.isMobileScreen) {
                this.$store.dispatch('couriers/STATE_SELECT_COURIER_ITEM', false);
            }
        },
        makeOrderLoading() {
            if (!this.makeOrderInfo.is_ok) {
                return;
            }
            this.$store.dispatch('couriers/CHANGE_STATE_NEW_COURIER', false);
            toast.success(__t('O.ORDER_CREATED_SUCCESSFULLY'));
            setTimeout(() => this.$store.dispatch('couriers/ORDERS_POS', {
                actionName: 'ordersPos',
                statesLoading: ['ordersPos.loading'],
                eventsList: ['loaded_orders_pos'],
                stateLoad: false,
            }), 3000);
            this.$router.push({path: "/courier"});
        },
        clickPayment(valueRadio) {
            this.selectPayment = valueRadio;
        },
        clickDeliveryOptions(valueRadio) {
            this.selectedDeliveryOption = valueRadio;
        },
    },
    computed: {
        ...mUser([
            'user',
        ]),
        ...mCouriers([
            'activeCourierOrder',
            'countAllCouriers',
            'selectLocationCourierNew',
            'search_order',
            'orderInfoByLocation',
            'makeOrderInfo',
            'isSelectCourierItem',
            'ordersPos',
            'selectLocationCourier',
            'orderRestLocations',
        ]),
        isShowCourier() {
            return (!this.isMobileScreen || (this.isMobileScreen && this.isSelectCourierItem)) && !this.isMakeOrder;
        },
        isCouriers() {
            if (this.countAllCouriers > 0 || this.activeCourierOrder) {
                return true;
            }
            return false;
        },
        totalSumWithCurrency() {
            if (this.user.currency_suffix && this.user.locale) {
                return this.toCurrency(this.totalSum, this.user.currency_suffix, 'uk-UA', 2);
            }
            return this.toCurrency(this.totalSum, '');
        },
        totalSum() {
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.prices.total')) {
                return this.orderInfoByLocation.order.prices.total;
            }
            return '';
        },
        activeCourierId() {
            if (this.activeCourierOrder && this.activeCourierOrder.id) {
                return this.activeCourierOrder.id;
            }
            return '';
        },
        clientAddress() {
            if (this.addressInfo.address && this.addressInfo.house && this.addressInfo.house !== '') {
                return this.addressInfo.address + ' ' + this.addressInfo.house;
            } else if (this.addressInfo.address) {
                return this.addressInfo.address;
            }
            return '';
        },
        isLoadingInfo() {
            return this.search_order.loading || this.orderInfoByLocation.loading;
        },
        isMakeOrder() {
            return this.makeOrderInfo.loading;
        },
        restName() {
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.rest.name')) {
                return this.orderInfoByLocation.order.rest.name;
            }
            return '';
        },
        restAddress() {
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.rest.address')) {
                return this.orderInfoByLocation.order.rest.address;
            }
            return '';
        },
        restAdministrator() {
            return '';
        },
        restPhone() {
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.rest.phone')) {
                return this.orderInfoByLocation.order.rest.phone;
            }
            return '';
        },
        clientDistance() {
            return '';
        },
        clientPhone() {
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.customer.phone')) {
                return this.orderInfoByLocation.order.customer.phone;
            }
            return '';
        },
        orderPositions() {
            let productsList = '';
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'order.products')) {
                if (Array.isArray(this.orderInfoByLocation.order.products)) {
                    this.orderInfoByLocation.order.products.forEach((item, index) => {
                        if (productsList !== '' && index !== 0) {
                            productsList = productsList + ', ';
                        }
                        if (item.qty) {
                            productsList = productsList + item.qty + ' x ';
                        }
                        if (item.name) {
                            productsList = productsList + item.name;
                        }
                    })
                }
            }
            return productsList;
        },
        orderInfoId() {
            if (this.orderInfoByLocation.order.order_code) {
                return this.orderInfoByLocation.order.order_code.toString();
            }
            return '';
        },
        orderInfoDateTime() {
            if (this.selectDate && this.selectTime) {
                return formatDateTime(this.selectDate, this.selectTime);
            }
            return formatDateTime(new Date(), new Date());
        },
        clientHouse() {
            if (this.addressInfo.house && this.addressInfo.house !== '') {
                return this.addressInfo.house;
            }
            return '';
        },
        dateFilled() {
            if (this.selectDate && this.selectTime) {
                return true;
            }
            return false;
        },
        newOrderData() {
            return {
                "order": {
                    "uniq_id": this.orderInfoId,
                    "asap": this.showBlockASAP,
                    "est_time": this.orderInfoDateTime,
                    "pickup_point": {
                        "instruction": this.restComment,
                        "phone": this.restPhone
                    },
                    "delivery_point": this.getDeliveryPoint,
                    "customer": {
                        "name": this.clientName,
                        "phone": this.clientPhone
                    }
                }
            }
        },
        payCash() {
            return this.selectedPayment === 1;
        },
        showBlockASAP() {
            return this.selectedDeliveryOption === 1;
        },
        showBlockDate() {
            return this.selectedDeliveryOption === 2;
        },
        addressStreet() {
            if (this.addressInfo.address) {
                const streetRegex = /(?:вул\.|вулиця|пров\.|провулок|проспект|пр\.)\s*([^\d,]+)\s*(\d+)/i;
                const streetMatch = this.addressInfo.address.match(streetRegex);
                return streetMatch ? streetMatch[1].trim() : '';
            }
            return '';
        },
        houseStreet() {
            if (this.addressInfo.house && this.addressInfo.house !== '') {
                return this.addressInfo.house;
            } else if (this.addressInfo.address) {
                const streetRegex = /(?:вул\.|вулиця|пров\.|провулок|проспект|пр\.)\s*([^\d,]+)\s*(\d+)/i;
                const streetMatch = this.addressInfo.address.match(streetRegex);
                return streetMatch ? streetMatch[2].trim() : '';
            }
            return '';
        },
        getDeliveryPoint() {
            if (this.addressInfo.address && this.addressInfo.address !== '' && (this.addressInfo.house === '' || this.addressInfo.house === null)) {
                return {
                    "address": this.addressInfo.address,
                    "street": '',
                    "house": '',
                    "comment": '',
                }
            } else {
                let comment = '';
                if (this.addressInfo.entrance && this.addressInfo.entrance !== '') {
                    comment += 'entrance ' + this.addressInfo.entrance + ', ';
                }
                if (this.addressInfo.flat && this.addressInfo.flat !== '') {
                    comment += 'flat ' + this.addressInfo.flat;
                }
                return {
                    "address": '',
                    "street": (this.addressInfo.address && this.addressInfo.address !== '') ? this.addressInfo.address : null,
                    "house": (this.addressInfo.house && this.addressInfo.house !== '') ? this.addressInfo.house : null,
                    "comment": comment,
                }
            }

        },
        timeASAP() {
            if (this.getObjectPathProperty(this.orderInfoByLocation.order, 'time.completeBefore.time')) {
                const asapDateTime = getDateTime(this.orderInfoByLocation.order.time.completeBefore.time);
                return formatDateTime(asapDateTime, asapDateTime, 'd.m.y');
            }
            return formatDateTime(new Date(), new Date(), 'd.m.y');
        },
        selectLocationProvider() {
            if (this.getObjectPathProperty(this.orderInfoByLocation, 'selectLocation.provider')) {
                return this.orderInfoByLocation.selectLocation.provider;
            }
            return {};
        },
        isShowMenu() {
            return !this.isMobileScreen || (this.isMobileScreen && !this.isSelectCourierItem);
        },
        classNoOrders() {
            if (!this.isCouriersList) {
                return 'center_content';
            }
            return '';
        },
        isCouriersList() {
            return this.countAllCouriersPos > 0;
        },
        // listOrders() {
        //     if (this.ordersPos && this.ordersPos.data && Array.isArray(this.ordersPos.data)) {
        //         return this.ordersPos.data;
        //     }
        //     return [];
        // },
        countAllCouriersPos() {
            if (this.ordersPos && this.ordersPos.data && Array.isArray(this.ordersPos.data)) {
                return this.ordersPos.data.length;
            }
            return 0;
        },
        iconAggregator() {
            if (this.getObjectPathProperty(this.activeCourierOrder, 'aggregator.icon')) {
                return this.activeCourierOrder.aggregator.icon;
            }
            return '';
        },
        listSelectLocations() {
            if (this.orderInfoByLocation && this.orderInfoByLocation.restLocations
                && Array.isArray(this.orderInfoByLocation.restLocations)) {
                return this.orderInfoByLocation.restLocations
            }
            return [];
        },
        titleAggregator() {
            if (this.getObjectPathProperty(this.selectLocationCourier, 'provider.title')) {
                return this.selectLocationCourier.provider.title;
            }
            return 'No title provider'
        },
        uniqIdLocation() {
            if (this.getObjectPathProperty(this.selectLocationCourier, 'uniq_id')) {
                return 'uniq_id: ' + this.selectLocationCourier.uniq_id;
            }
            return 'No uniq_id'
        },
        // optionsLocations() {
        //     console.log(this.orderRestLocations[0])
        //     if(this.orderRestLocations && Array.isArray(this.orderRestLocations)){
        //         return this.orderRestLocations
        //     }
        //     return [];
        // }
    }
}
</script>

<style scoped>
    .vs__selected {
        padding: 0
    }
</style>
